import { Row, Tabs, Collapse } from 'antd';
import { styled } from 'styled-components';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import ScrollAnimation from 'react-animate-on-scroll';

import { 
    usageQuestions,
    planQuestions,
    competitionQuestions,
    stepCompetitionQuestions,
    aiCompetitionQuestions
} from '../data/faq';
import img_faq_pet from '../assets/img_faq_pet.png';

const FaqWrapper = styled.div`
    padding: 30px 12vw;
    margin-bottom: 50px;
    position: relative;

    @media screen and (max-width: 768px) {
        padding: 30px 6vw;
    }

    .ant-tabs-nav::before {
        content: none;
    }

    .ant-tabs-nav-operations {
        display: none !important; 
    }

    .ant-tabs-nav-wrap {
        overflow: visible !important;

        &::before {
            content: none !important;
        }
    }

    .ant-tabs-tab-btn {
        font-size: 24px;
        font-weight: bold;
        line-height: 36px;
        color: #45B9AE;

        &:focus {
            color: #45B9AE !important;
        }
    }

    .ant-tabs-tab-active .ant-tabs-tab-btn {
        color: #45B9AE !important;
    }

    .ant-tabs-ink-bar {
        background-color: #FFCF2E;
        height: 4px !important;
        bottom: 6px !important;
    }

    .ant-collapse-header {
        align-items: center !important;
    }

    .ant-collapse-header-text {
        font-size: 20px;
        line-height: 32px;
        color: #101720;
    }

    .ant-collapse-content-box {
        font-size: 20px;
        line-height: 32px;
        color: #585A5E;

        a {
            font-weight: bold;
            text-decoration: underline;
            color: #1385C8;
        }
    }
`;

const TarbitImg = styled.img`
    width: 180px;
    position: absolute;
    left: 100px;
    top: -40px;

    @media screen and (max-width: 768px) {
        left: -50px;
    }
`;

const Header = styled(Row)`
    color: #1385C8;
    font-size: 56px;
    font-weight: bold;
    line-height: 76px;
    width: 100%;
    justify-content: center;
    margin-bottom: 60px;

    @media screen and (max-width: 768px) {
        font-size: 36px;
        line-height: 48px;
    }
`;

const Topic = styled.div`
    font-size: 20px;
    font-weight: bold;
    line-height: 36px;
    color: #45B9AE;
    margin: 30px 0px;
    position: relative;
`;

const FAQ = () => {

    const collapseStyle = {
        marginBottom: '20px',
        backgroundColor: '#DCF5F2',
        borderRadius: '15px',
        border: 'none',
        padding: '10px'
    };

    const tabItems = [
        {
            key: '1',
            label: 'Workute 使用',
            children: (
                <Collapse
                    bordered={false}
                    defaultActiveKey={['0']}
                    expandIconPosition='right'
                    style={{ backgroundColor: '#FFFFFF' }}
                    expandIcon={({ isActive }) => isActive ?<UpOutlined style={{ color: '#1385C8', fontSize: '20px', transform: 'scale(1.5, 1)' }} /> : <DownOutlined style={{ color: '#1385C8', fontSize: '20px', transform: 'scale(1.5, 1)' }} />}
                    items={usageQuestions.map((val, i) => ({
                        key: i.toString(),
                        label: val.title,
                        children: val.content,
                        style: collapseStyle
                    }))}
                />
            )
        },
        {
            key: '2',
            label: '企業方案',
            children: (
                <Collapse
                    bordered={false}
                    defaultActiveKey={['0']}
                    expandIconPosition='right'
                    style={{ backgroundColor: '#FFFFFF' }}
                    expandIcon={({ isActive }) => isActive ?<UpOutlined style={{ color: '#1385C8', fontSize: '20px', transform: 'scale(1.5, 1)' }} /> : <DownOutlined style={{ color: '#1385C8', fontSize: '20px', transform: 'scale(1.5, 1)' }} />}
                    items={planQuestions.map((val, i) => ({
                        key: i.toString(),
                        label: val.title,
                        children: val.content,
                        style: collapseStyle
                    }))}
                />
            )
        },
        {
            key: '3',
            label: '賽事相關',
            children: (
                <div>
                    <Collapse
                        bordered={false}
                        defaultActiveKey={['0']}
                        expandIconPosition='right'
                        style={{ backgroundColor: '#FFFFFF' }}
                        expandIcon={({ isActive }) => isActive ?<UpOutlined style={{ color: '#1385C8', fontSize: '20px', transform: 'scale(1.5, 1)' }} /> : <DownOutlined style={{ color: '#1385C8', fontSize: '20px', transform: 'scale(1.5, 1)' }} />}
                        items={competitionQuestions.map((val, i) => ({
                            key: i.toString(),
                            label: val.title,
                            children: val.content,
                            style: collapseStyle
                        }))}
                    />
                    <Topic>步行賽</Topic>
                    <Collapse
                        bordered={false}
                        expandIconPosition='right'
                        style={{ backgroundColor: '#FFFFFF' }}
                        expandIcon={({ isActive }) => isActive ?<UpOutlined style={{ color: '#1385C8', fontSize: '20px' }} /> : <DownOutlined style={{ color: '#1385C8', fontSize: '20px' }} />}
                        items={stepCompetitionQuestions.map((val, i) => ({
                            key: i.toString(),
                            label: val.title,
                            children: val.content,
                            style: collapseStyle
                        }))}
                    />
                    <Topic>AI 動作賽事</Topic>
                    <Collapse
                        bordered={false}
                        expandIconPosition='right'
                        style={{ backgroundColor: '#FFFFFF' }}
                        expandIcon={({ isActive }) => isActive ?<UpOutlined style={{ color: '#1385C8', fontSize: '20px' }} /> : <DownOutlined style={{ color: '#1385C8', fontSize: '20px' }} />}
                        items={aiCompetitionQuestions.map((val, i) => ({
                            key: i.toString(),
                            label: val.title,
                            children: val.content,
                            style: collapseStyle
                        }))}
                    />
                </div>
            )
        }
    ];

    return (
        <FaqWrapper id='faq'>
            <ScrollAnimation animateIn='fadeIn' animateOnce>
                <Header>
                    常見問題
                </Header>
                <TarbitImg src={img_faq_pet} alt='img_faq_pet' />
                <Tabs
                    defaultActiveKey='1'
                    centered
                    more={{ icon: <></> }}
                    items={tabItems}
                />
            </ScrollAnimation>
        </FaqWrapper>
    );
};

export default FAQ;
